import type { RegionId } from "./regions";

export type RegionLocale = {
  id: RegionId;
  currencyCode: "GBP" | "USD";
  currencySymbol: "£" | "$";
  localeTag: "en-GB" | "en-US";
};

const UK_LOCALE: RegionLocale = {
  id: "uk",
  currencyCode: "GBP",
  currencySymbol: "£",
  localeTag: "en-GB",
};

const US_LOCALE: RegionLocale = {
  id: "us",
  currencyCode: "USD",
  currencySymbol: "$",
  localeTag: "en-US",
};

/**
 * Resolve display locale from session region.
 * Defaults to UK when region is unset (intro incomplete / legacy sessions).
 */
export function getRegionLocale(
  regionId: RegionId | null | undefined,
): RegionLocale {
  return regionId === "us" ? US_LOCALE : UK_LOCALE;
}

export function getCurrencySymbol(
  regionId: RegionId | null | undefined,
): RegionLocale["currencySymbol"] {
  return getRegionLocale(regionId).currencySymbol;
}

/**
 * Apply British spellings for UK; leave US English copy unchanged for US.
 * Source strings in the app and `src/data` are written in US English.
 */
export function toRegionalSpelling(
  text: string,
  regionId: RegionId | null | undefined,
): string {
  if (getRegionLocale(regionId).id === "us") {
    return text;
  }

  return text
    .replace(/\bLabor\b/g, "Labour")
    .replace(/\blabor\b/g, "labour")
    .replace(/\bOptimized\b/g, "Optimised")
    .replace(/\boptimized\b/g, "optimised")
    .replace(/\bCustomized\b/g, "Customised")
    .replace(/\bcustomized\b/g, "customised")
    .replace(/\bOrganization\b/g, "Organisation")
    .replace(/\borganization\b/g, "organisation")
    .replace(/\bUnanalyzed\b/g, "Unanalysed")
    .replace(/\bunanalyzed\b/g, "unanalysed")
    .replace(/\bAnalyzing\b/g, "Analysing")
    .replace(/\banalyzing\b/g, "analysing")
    .replace(/\bAnalyzed\b/g, "Analysed")
    .replace(/\banalyzed\b/g, "analysed")
    .replace(/\bAnalyze\b/g, "Analyse")
    .replace(/\banalyze\b/g, "analyse")
    .replace(/\bLicense\b/g, "Licence")
    .replace(/\blicense\b/g, "licence")
    .replace(/\bFulfillment\b/g, "Fulfilment")
    .replace(/\bfulfillment\b/g, "fulfilment")
    .replace(/\bCanceled\b/g, "Cancelled")
    .replace(/\bcanceled\b/g, "cancelled")
    .replace(/\bAnnualized\b/g, "Annualised")
    .replace(/\bannualized\b/g, "annualised");
}
